import Channels from '@/models/Channels'
import { AxiosInstance } from 'axios'
// import LocationCommunities from '@/models/LocationCommunities'
import config from '@/config'
import Comments from '@/models/Comments'
import ContentReports from '@/models/ContentReports'
import Conversations from '@/models/Conversation'
import Forms from '@/models/Forms'
import Groups from '@/models/Groups'
import Imports from '@/models/Imports'
import Invitations from '@/models/Invitations'
import Listings from '@/models/Listings'
import Model from '@/models/Model'
import Posts from '@/models/Posts'
import Reactions from '@/models/Reaction'
import Search from '@/models/search'
import Users from '@/models/Users'
import { requests } from './HTTPService'

export type TypesModels =
  | Groups
  | Channels
  | Users
  | Posts
  | Comments
  | Reactions
  | Invitations
  | Forms
  | ContentReports
  | Conversations
  | Search
  | Listings
  | Imports

export interface IBaseResponse<T> {
  data: T
  status: number
  message?: string
}

const defaultHttp = requests(config.COMMUNITIES_SERVER_URL)

export default abstract class BaseService<T extends TypesModels> {
  protected basePath = ''
  protected http: AxiosInstance
  readonly locationId: string

  abstract model(): typeof Model

  constructor(locationId: string, httpInstance: AxiosInstance = defaultHttp) {
    this.locationId = locationId
    this.http = httpInstance
  }

  get endpoint(): string {
    return `${this.basePath}`
  }

  async findById(id: string, params?: Record<string, any>): Promise<T> {
    const response = await this.http.get(`${this.endpoint}/${id}`, { params })
    return new (this.model())(response.data, this) as T
  }

  async create(data: Record<string, any>): Promise<IBaseResponse<T>> {
    const response = await this.http.post(`${this.endpoint}`, data)
    return response.data
  }

  async update(
    id: string,
    data: Record<string, any>
  ): Promise<IBaseResponse<T>> {
    const response = await this.http.put(`${this.endpoint}/${id}`, data)
    return response.data
  }

  async delete(id: string): Promise<IBaseResponse<void>> {
    const response = await this.http.delete(`${this.endpoint}/${id}`)
    return response.data
  }

  async findAll(params?: Record<string, any>): Promise<IBaseResponse<T[]>> {
    const response = await this.http.get(`${this.endpoint}`, { params })
    return response.data
  }
}
